export const specializations = [
    {
      id: 1,
      name: "Software Engineering",
      children: [
        {
          name: "Database",
          children: [
            {
              name: "Normalization",
            },
            {
              name: "Big Data",
            },
          ],
        },
        {
          name: "Design Patterns",
          children: [
            {
              name: "Strategy Pattern",
            },
            {
              name: "Repository Pattern",
            },
            {
              name: "Domain Driven Design",
            },
            {
              name: "Command and Query Responsibility Segregatio",
            },
            {
              name: "Model View Controller",
            },
            {
              name: "Model View View-Model",
            },
          ],
        },
        {
          name: "Programming Styles",
          children: [
            {
              name: "Object Oriented",
            },
            {
              name: "Functional",
            },
            { name: "Don't Repeat Yourself" },
            { name: "SOLID Principles" },
          ],
        },
        {
          name: "Architectures",
          children: [
            {
              name: "Monolitic",
            },
            {
              name: "Micro-service",
            },
            {
              name: "Stateful and Stateless",
            },
          ],
        },
        {
          name: "Development Operations",
          children: [
            {
              name: "Containerization",
            },
            {
              name: "Version Controling Source",
            },
            {
              name: "Queue System Management",
            },
            {
              name: "Continues Integration Pipelining",
            },
            {
              name: "Continues Development Pipelining",
            },
            {
              name: "Content Delivery Networks",
            },
          ],
        },
        {
          name: "Optimization and Performance",
          children: [
            {
              name: "Memory Management",
            },
            {
              name: "Algorithm Time Complexity",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      name: "Startup Specialist",
      children: [
        {
          name: "Startup Ecosystem",
          children: [
            {
              name: "Minimal Viable Product",
            },
            {
              name: "Business Models",
            },
          ],
        },
  
        {
          name: "Efficient Collaboration",
          children: [{ name: "Slack" }],
        },
        {
          name: "Project Management",
          children: [{ name: "Notion" }],
        },
        {
          name: "Knowledges",
          children: [
            { name: "Economic Cycles" },
            { name: "Accounting Principles" },
          ],
        },
        {
          name: "Agile Development",
          children: [],
        },
        {
          name: "Complex Problem-Solving",
          children: [],
        },
      ],
    },
    {
      id: 3,
      name: "Backend Developing",
      children: [
        {
          name: "Languages",
          children: [
            { name: "PHP", progress: 100 },
            { name: "Javascript", progress: 90 },
            { name: "Nodejs", progress: 60 },
            { name: "C", progress: 30 },
            { name: "Rust", progress: 30 },
          ],
        },
        {
          name: "Frameworks",
          children: [
            { name: "Laravel", progress: 100 },
            { name: "ExpressJs", progress: 80 },
            { name: "Custom", progress: 60 },
          ],
        },
        {
          name: "Skills",
          children: [
            { name: "Complex Role-Permissions" },
            { name: "Files and conversions" },
            { name: "Log-based design" },
            { name: "Websockets and Realtime" },
            { name: "Test Units" },
          ],
        },
        {
          name: "Security Measures",
          children: [
            { name: "Content Security Policies" },
            { name: "Access Origin Principles" },
            { name: "Encryption Functions" },
            { name: "XSS Preventation" },
          ],
        },
        {
          name: "Performance",
          children: [
            { name: "Smart Caching Mechanisms" },
            { name: "Query Optimizations" },
            { name: "Queue Pipeline Management" },
            { name: "Round Robin Gateways" },
          ],
        },
      ],
    },
    {
      id: 4,
      name: "Frontend Developing",
      children: [
        {
          name: "Languages",
          children: [
            { name: "HTML", progress: 100 },
            { name: "Javascript", progress: 90 },
            { name: "CSS", progress: 85 },
            { name: "SCSS", progress: 70 },
          ],
        },
        {
          name: "Frameworks",
          children: [
            { name: "ReactJS", progress: 95 },
            { name: "React Native", progress: 75 },
            { name: "Angular", progress: 60 },
            { name: "ReduxJS", progress: 85 },
            { name: "Tailwind-CSS", progress: 80 },
            { name: "Custom", progress: 90 },
          ],
        },
        {
          name: "Skills",
          children: [
            { name: "Server-Side Rendering" },
            { name: "IndexedDB" },
            { name: "Intervals and Timeouts Usages" },
            { name: "Object and Array Manipulation" },
            { name: "Animations" },
            { name: "Complex State Managements" },
          ],
        },
        {
          name: "Performance",
          children: [
            { name: "Promises and Asyncronous" },
            { name: "Memoization" },
          ],
        },
      ],
    },
  ];